<template>
  <div>
    <!-- Header -->
    <section class="page-header">
      <div class="container">
        <span class="label-tag">Contact</span>
        <h1>Let's Talk</h1>
        <p class="page-header-sub">
          Whether you have a specific project in mind or want to explore how
          I can support your club, I'd be glad to hear from you.
        </p>
      </div>
    </section>

    <!-- Contact Content -->
    <section class="section section-alt">
      <div class="container">
        <div class="row g-5">
          <div class="col-lg-7">
            <div class="divider"></div>
            <h2>Send a Message</h2>
            <p class="contact-intro">
              Fill in the form below and I'll get back to you as soon as possible.
            </p>
            <form @submit.prevent="sendEmail" class="contact-form">
              <div class="row g-3">
                <div class="col-md-6">
                  <label for="name" class="form-label">Name</label>
                  <input
                    type="text"
                    id="name"
                    v-model="form.name"
                    class="form-control custom-input"
                    required
                  />
                </div>
                <div class="col-md-6">
                  <label for="email" class="form-label">Email</label>
                  <input
                    type="email"
                    id="email"
                    v-model="form.email"
                    class="form-control custom-input"
                    required
                  />
                </div>
                <div class="col-12">
                  <label for="subject" class="form-label">Subject</label>
                  <input
                    type="text"
                    id="subject"
                    v-model="form.subject"
                    class="form-control custom-input"
                  />
                </div>
                <div class="col-12">
                  <label for="message" class="form-label">Message</label>
                  <textarea
                    id="message"
                    v-model="form.message"
                    class="form-control custom-input"
                    rows="6"
                    required
                  ></textarea>
                </div>
                <div class="col-12">
                  <button type="submit" class="btn-primary-custom">
                    Send Message
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="col-lg-4 offset-lg-1">
            <div class="contact-sidebar">
              <div class="contact-block">
                <h3>Email</h3>
                <a href="mailto:chris@thematchanalyst.co.uk" class="contact-link">
                  chris@thematchanalyst.co.uk
                </a>
              </div>
              <div class="contact-block">
                <h3>Based in</h3>
                <p class="contact-detail">United Kingdom</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ContactView',
  data() {
    return {
      form: {
        name: '',
        email: '',
        subject: '',
        message: ''
      }
    }
  },
  methods: {
    sendEmail() {
      const subject = encodeURIComponent(this.form.subject || 'Enquiry from website')
      const body = encodeURIComponent(
        `Name: ${this.form.name}\nEmail: ${this.form.email}\n\n${this.form.message}`
      )
      window.location.href = `mailto:chris@thematchanalyst.co.uk?subject=${subject}&body=${body}`
    }
  }
}
</script>

<style scoped>
.page-header {
  padding: 160px 0 80px;
  background: linear-gradient(160deg, var(--navy-dark) 0%, var(--navy) 100%);
}

.page-header h1 {
  margin-bottom: 1rem;
}

.page-header-sub {
  color: var(--silver);
  font-size: 1.15rem;
  max-width: 520px;
}

.contact-intro {
  color: var(--silver);
  font-size: 1.05rem;
  margin-bottom: 2rem;
}

.form-label {
  color: var(--silver-light);
  font-size: 0.85rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-bottom: 0.5rem;
}

.custom-input {
  background: var(--navy-medium);
  border: 1px solid var(--border-subtle);
  color: var(--white);
  border-radius: 4px;
  padding: 0.75rem 1rem;
  font-family: var(--font-body);
  font-size: 0.95rem;
  transition: border-color 0.2s ease;
}

.custom-input:focus {
  background: var(--navy-medium);
  border-color: var(--accent);
  color: var(--white);
  box-shadow: 0 0 0 3px rgba(74, 124, 201, 0.15);
}

.custom-input::placeholder {
  color: var(--silver);
  opacity: 0.5;
}

.contact-sidebar {
  background: var(--navy-medium);
  border: 1px solid var(--border-subtle);
  border-radius: 8px;
  padding: 2.5rem;
  margin-top: 3.5rem;
}

.contact-block {
  margin-bottom: 2rem;
}

.contact-block:last-child {
  margin-bottom: 0;
}

.contact-block h3 {
  font-family: var(--font-body);
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--silver);
  margin-bottom: 0.75rem;
}

.contact-link {
  color: var(--accent);
  font-size: 1rem;
  word-break: break-all;
}

.contact-link:hover {
  color: var(--white);
}

.contact-detail {
  color: var(--silver-light);
  font-size: 1rem;
  margin-bottom: 0;
}
</style>
